export default "__VITE_ASSET__B0v72NXu__"